import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

export const RenderImageCell = (cellData: any) => {
  const { data } = cellData;
  const base64String = data.image || data.imageLink;
  const [showModal, setShowModal] = useState(false);

   if (!base64String || base64String.trim() === "") {
    return null;
  }

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src={base64String}
          onClick={handleShow}
          style={{
            width: '60px',
            height: '60px',
            objectFit: 'cover',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'block',
          }}
        />
      </div>

      <Modal show={showModal} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Image Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <img
            src={base64String}
            alt="Full Size"
            style={{
              maxWidth: '100%',
              maxHeight: '80vh',
              objectFit: 'contain',
            }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};
